import DOMPurify from 'dompurify';
export const preventXss = (unsanitizedString) => {
  const sanitizedString = DOMPurify.sanitize(unsanitizedString);
  return sanitizedString;
};
export const preventCSRF = (tokenName = 'csrfToken') => {
  // eslint-disable-next-line
  const regex = new RegExp(`${tokenName}=([\w-]+)`);
  const csrfToken = document.cookie.match(regex);
  if (csrfToken) {
    const token = csrfToken[1];
    const forms = document.getElementsByTagName('form');
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < forms.length; i++) {
      const form = forms[i];
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'csrfToken';
      input.value = token;
      form.appendChild(input);
    }
  }
};
